import { TakePicture } from '~/components';
import { MaskType } from '~/utils';

interface OnboardingSelfieProps {
  handleSubmit: (image: string) => Promise<void>;
}

const OnboardingSelfie = ({ handleSubmit }: OnboardingSelfieProps) => {
  return (
    <TakePicture
      handleSubmit={handleSubmit}
      sceneTitle="Selfie"
      maskType={MaskType.FACE}
    />
  );
};

export default OnboardingSelfie;
